
















































import { Vue, Component } from "vue-property-decorator";

@Component
export default class PriceSurchargeModal extends Vue {
  protected surchargeValue: string =
    process.env.VUE_APP_PRICE_SURCHARGE_VALUE_STRING || "0%";
  protected surchargeDate: string =
    process.env.VUE_APP_PRICE_SURCHARGE_DATE || "2025";
  protected closeModal(): void {
    this.$emit("close");
  }
}
